<template>
  <div style="width:100%;padding-bottom:0.2rem">
    <Header :title="$t('m.ScheduleMeetingList')"></Header>
    <div class="list">
      <div :key="index" class="listitem spebgc" v-for="(item,index) in meetingwill">
        <div class="title color" @click="tomeetingdetail(item.id)">{{$t('m.MeetingNoticeColon')}}{{item.meeting_name}}</div>
        <div class="content">
          <div class="left">
            <img alt src="../../assets/images/public/erweima.png" />
          </div>
          <div class="right">
            <p>{{$t('m.MeetingNoColon')}}{{item.vmr_id}}</p>
            <!-- <p>{{$t('m.StartTimeColon')}}{{item.meeting_date| gettime}}</p> -->
            <p>{{$t('m.StartTimeColon')}}{{gettime(item.meeting_date)}}</p>
            <p>{{$t('m.MeetingDurationColon')}}{{item.meeting_long}}{{$t('m.Minute')}}</p>
          </div>
        </div>
        <!-- <div class="bottom">
          <span>阅读全文</span>
          <Icon class="right color" type="md-arrow-round-forward" />
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header";
import { selectConfList } from "../../assets/js/url";

export default {
  name: "attendmeetinglist",
  data() {
    return {
      meetingwill: [],
      start: 0
    };
  },
  components: {
    Header
  },
  activated() {
    this.getmeetwilllist();
  },
  filters: {
    getdata(value) {
      const data = new Date(value.split(".")[0].replace(/\-/g, "/"));
      return (
        data.getFullYear() + "/" + (data.getMonth() + 1) + "/" + data.getDate()
      );
    },
    gettime(value) {
      const data = new Date(value.split(".")[0].replace(/\-/g, "/"));
      const datanow = new Date();
      if (data.getTime() > datanow.getTime()) {
        if (data.getFullYear() > datanow.getFullYear()) {
          return data.getFullYear() - datanow.getFullYear() + this.$t('m.AfterYear');
        }
        if (data.getMonth() > datanow.getMonth()) {
          return data.getMonth() - datanow.getMonth() + this.$t('m.AfterMonth');
        }
        if (data.getDate() > datanow.getDate()) {
          return data.getDate() - datanow.getDate() + this.$t('m.AfterDay');
        }
        if (data.getHours() > datanow.getHours()) {
          return data.getHours() - datanow.getHours() + this.$t('m.AfterHour');
        }
        if (data.getMinutes() > datanow.getMinutes()) {
          return data.getMinutes() - datanow.getMinutes() + this.$t('m.AfterMinute');
        }
      } else {
        if (data.getFullYear() < datanow.getFullYear()) {
          return Math.abs(data.getFullYear() - datanow.getFullYear()) + this.$t('m.BeforeYear');
        }
        if (data.getMonth() < datanow.getMonth()) {
          return Math.abs(data.getMonth() - datanow.getMonth()) + this.$t('m.BeforeMonth');
        }
        if (data.getDate() < datanow.getDate()) {
          return Math.abs(data.getDate() - datanow.getDate()) + this.$t('m.BeforeDay');
        }
        if (data.getHours() < datanow.getHours()) {
          return Math.abs(data.getHours() - datanow.getHours()) + this.$t('m.BeforeHour');
        }
        if (data.getMinutes() < datanow.getMinutes()) {
          return Math.abs(data.getMinutes() - datanow.getMinutes()) + this.$t('m.BeforeMinute');
        }
      }
    }
  },
  methods: {
    gettime(value) {
      const data = new Date(value.split(".")[0].replace(/\-/g, "/"));
      const datanow = new Date();
      if (data.getTime() > datanow.getTime()) {
        if (data.getFullYear() > datanow.getFullYear()) {
          return data.getFullYear() - datanow.getFullYear() + this.$t('m.AfterYear');
        }
        if (data.getMonth() > datanow.getMonth()) {
          return data.getMonth() - datanow.getMonth() + this.$t('m.AfterMonth');
        }
        if (data.getDate() > datanow.getDate()) {
          return data.getDate() - datanow.getDate() + this.$t('m.AfterDay');
        }
        if (data.getHours() > datanow.getHours()) {
          return data.getHours() - datanow.getHours() + this.$t('m.AfterHour');
        }
        if (data.getMinutes() > datanow.getMinutes()) {
          return data.getMinutes() - datanow.getMinutes() + this.$t('m.AfterMinute');
        }
      } else {
        if (data.getFullYear() < datanow.getFullYear()) {
          return Math.abs(data.getFullYear() - datanow.getFullYear()) + this.$t('m.BeforeYear');
        }
        if (data.getMonth() < datanow.getMonth()) {
          return Math.abs(data.getMonth() - datanow.getMonth()) + this.$t('m.BeforeMonth');
        }
        if (data.getDate() < datanow.getDate()) {
          return Math.abs(data.getDate() - datanow.getDate()) + this.$t('m.BeforeDay');
        }
        if (data.getHours() < datanow.getHours()) {
          return Math.abs(data.getHours() - datanow.getHours()) + this.$t('m.BeforeHour');
        }
        if (data.getMinutes() < datanow.getMinutes()) {
          return Math.abs(data.getMinutes() - datanow.getMinutes()) + this.$t('m.BeforeMinute');
        }
      }
    },
    getmeetwilllist() {
      this.$http
        .post(selectConfList, {
          useruuid: window.sessionStorage.getItem("UUID"),
          type: 2,
          start: this.start,
          pagesize: 50
        })
        .then(res => {
          if (res.data.status == 2000) {
            this.meetingwill = res.data.data;
            if (!this.meetingwill.length) {
              this.$toast(this.$t('m.NowNoPlanMeetingList'));

              setTimeout(function() {
                _this.$router.push("/index");
              }, 2000);
            }
          }
        });
    },
    tomeetingdetail(item) {
      this.$router.push({
        name: "meetingdetail",
        query: {
          meetinguuid: item
        }
      });
    }
  }
};
</script>
<style scoped>
.list {
  box-sizing: border-box;
  padding: 0 0.15rem;
}

.listitem {
  height: 1.5rem;
  border-radius: 6px;
  margin-top: 0.15rem;
  box-sizing: border-box;
  padding: 0.15rem;
}

.left {
  float: left;
  width: 1rem;
  height: 1rem;
}

.left img {
  width: 100%;
  height: 100%;
}

.right {
  float: right;
}

.right p {
  line-height: 0.2rem;
  font-size: 0.15rem;
  margin-top: 0.05rem;
}

.title {
  height: 0.21rem;
  line-height: 0.21rem;
  font-size: 0.15rem;
}

.content {
  height: 1rem;
  margin-top: 0.15rem;
}

.bottom {
  margin-top: 0.15rem;
  height: 0.21rem;
  line-height: 0.21rem;
  font-size: 0.15rem;
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/content/attendmeetinglist.vue